var exports = {
  "iE": "xaee3c4fa--c4ee86--wrapper",
  "BH": "xaee3c4fa--c4ee86--tabs-wrapper",
  "Mf": "xaee3c4fa--c4ee86--tab",
  "A1": "xaee3c4fa--c4ee86--_active",
  "mR": "xaee3c4fa--c4ee86--tabs-after",
};

module.exports = exports;
